<div class="panel">
  <div class="border-b border-gray-200">
    <div class="px-8 h-20 items-center flex gap-3">
      <!-- The list heading is the button that opens its menu (TW-PANEL-07): named by its text, Enter and Space native. -->
      <button
        type="button"
        class="bg-transparent border-0 p-0 [font:inherit] text-inherit text-left cursor-pointer"
        appDPEventsContextMenu
        (appDPContextMenuOpened)="contextMenuOpened = $event"
        (appDPContextMenuFilterChanged)="selectFilter($event)"
        aria-haspopup="menu"
        [attr.aria-expanded]="!!contextMenuOpened"
      >
        <app-dropdown-label [collapsed]="!contextMenuOpened">
          {{ selectedFilter | titleByEventsFilter}}
        </app-dropdown-label>
      </button>

      <div class="grow"></div>

      @if (selectedFilter !== 'all_calendars') {
        <app-calendars-picker
          class="max-w-96"
          render="text"
          size="s"
          [multiple]="true"
          [value]="selectedCalendarUids()"
          (valueChange)="handleCalendarsChange($event)"
        />

        <app-context-menu-state-indicator
          svgIcon="filters"
          appEventsListContextMenu
          [appEventsListContextMenuWithAdvancedSearch]="true"
        />
      }
      @if (selectedFilter === 'all_calendars') {
        <app-context-menu-state-indicator
          svgIcon="filters"
          appCalendarsListContextMenu
          [appCalendarsListContextMenuWithAdvancedSearch]="true"
        />
      }
      <app-search-state-indicator
        [applied]="isSearchApplied()"
        (clear)="clearSearch()"
      >
        <app-icon
          class="max-w-8 max-h-8 text-gray-500 cursor-pointer items-center"
          name="search-small"
          stchPopover
          stchPopoverPlacement="bottomRight"
          stchPopoverTrigger="click"
          [stchPopoverContent]="searchPopover"
          [stchPopoverFallbackPlacements]="[]"
          [stchPopoverShowUntil]="popoverClose"
        />
      </app-search-state-indicator>
    </div>

    <!--
      Both quick-form triggers sit inside the header block here, unlike the other five panels, which
      render theirs below it. SBUX-930 asks for the Events button "above the monthly calendar view", and
      that calendar is the date picker below — so the Events trigger has to be here, and its Calendars
      sibling follows it rather than being left on its own beneath the tab strip.
    -->
    @if ((selectedTab === 'events' || selectedTab === 'today') && creationAllowed()) {
      <app-quick-form
        class="panel-quick-form border-t border-gray-200" trigger="button" [collapseKey]="selectedFilter"
        placeholder="Add New Event"
      >
        <app-event-quick-form
          [showMore]="true"
          [destinationTenantId]="calendarTenantScope?.effectiveTenantId() ?? undefined"
          (more)="handleNewEvent($event)"
        />
      </app-quick-form>
    }

    @if (selectedTab === 'calendars' && creationAllowed()) {
      <app-quick-form
        class="panel-quick-form" trigger="button" [collapseKey]="selectedFilter"
        placeholder="Add New Calendar"
      >
        <app-calendar-quick-form [showMore]="true" (more)="handleNewCalendar($event)" />
      </app-quick-form>
    }

    @if (selectedFilter === 'all_events' && !isAdvancedSearchApplied()) {
      <app-date-picker-2
        class="panel-date-picker"
        [inputFormControl]="selectedDateControl"
        [collapseable]="true"
        [collapsed]="true"
        [monthArrows]="false"
        (activeDateChange)="handleDatepickerActiveDateChange($event)"
        (eventDropped)="handleDrop($event)"
      />
    }

    @if (selectedFilter !== 'all_calendars') {
      <!-- 12px above the tabs, off the month's line (Johanna, 2026-11-01). -->
      <app-tabs
        class="panel-heading-tabs pt-6"
        selectedStateKey="dpEvents"
        [values]="tabs"
        [value]="selectedTab"
        (valueChange)="onTabChange($event)"
        />
    }
    </div>

    <div class="panel-list flex flex-col">
      @if (selectedTab === 'calendars') {
        <app-calendars-list
          [filters]="calendarsFilters"
          (openCalendar)="openCalendar($event)"
          (doubleClickCalendar)="openCalendar($event)"
        />
      }

      @if (selectedTab === 'today') {
        <!-- The arrows step the day, around its name (Johanna, 2026-11-01), not the month above. -->
        <stch-calendar-date-nav
          [view]="CalendarType.DAY"
          [date]="selectedDateControl.value"
          (previous)="stepDay(-1)"
          (next)="stepDay(1)"
        />
        <stch-calendar-day
          class="h-full min-h-0"
          [viewDate]="selectedDateControl.value"
          [events]="events"
          [showDayHeader]="false"
          [scrollToDate]="calendarScrollToTime()"
          (dateClicked)="handleDateClicked($event)"
          (eventDropped)="handleDrop($event)"
          (eventClicked)="openEventInModal($event)"
        />
      }

      @if (selectedTab === 'events' && eventsFilters()) {
        @if (eventsListMode() === ListMode.LIST) {
          <app-events-list
            [filters]="eventsFilters()"
            [showLocationBadge]="isAdvancedSearchApplied()"
            (doubleClickEvent)="openEvent($event)"
          />
        } @else {
          @if (!isAdvancedSearchApplied()) {
            <stch-sticky-events-list
              class="max-h-[287px] overflow-y-auto"
              [filters]="eventsFilters()"
              (doubleClickEvent)="openEvent($event)"
            />
          }

          <app-time-range-events-list
            [filters]="eventsFilters()"
            (doubleClickEvent)="openEvent($event)"
          />
        }
      }
    </div>
  <div>
</div>

<ng-template #popoverFormTemplate>
  <stch-event-popover-form
    [event]="calendarEvent"
    (close)="handlePopoverFormClose()"
  />
</ng-template>

<ng-template #searchPopover>
  <app-calendar-search-popover
    [width]="600"
    (onSearch)="handleSearch()"
    (onCancel)="handleCancel()"
  />
</ng-template>
